import { render, staticRenderFns } from "./Solucloud.vue?vue&type=template&id=6626870b&scoped=true&"
import script from "./Solucloud.vue?vue&type=script&lang=js&"
export * from "./Solucloud.vue?vue&type=script&lang=js&"
import style0 from "./Solucloud.vue?vue&type=style&index=0&id=6626870b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626870b",
  null
  
)

export default component.exports